//Quote Reject Reasons enum
export enum QuoteReasons {
  NEW_CAPACITY = "Not enough capacity on Flight",
  UNACCEPTABLE_DIMMENSIONS = "Can't accept those dimensions on this aircraft",
  SHORT_TRANSIT_TIME = "Too short transit time",
  UNABLE_TO_ACCEPT_ON_AIRCRAFT = "Can't accept this product on this aircraft",
  UNABLE_TO_ACCEPT_ON_NETWORK = "Can't accept this product on our network",
  FORWARDER_FINANCE = "Can't accept forwarder due to finance",
  FORWARDER_OTHER_REASONS = "Can't accept forwarder due to other reasons",
  NO_SHOW_CUSTOMER = "No Show / late delivery / booking rescheduled by customer",
  OPERATIONAL_DISRUPTIONS = "Operational disruptions (customs, screening delay, quality issues with shipment, etc.)",
  CARGO_DETAILS_CHANGED = "Cargo details have changed",
  ALTERNATE_DOESNT_MEET_REQUIREMENTS = "The alternate date/time/rate offered doesn't meet my requirements",
  PLACED_BOOKING_ANOTHER_WAY = "I have placed the booking in another way (email/phone)",
  FORCE_MAJEURE = "Force majeure",
}

export enum QuoteReasonMsg {
  NO_REASON = "Please enter a reason and press apply to confirm.",
  MISSING_CAP = "Please enter remaining available capacity and press apply to confirm.",
  POSTIVE_CAP = "Please enter positive number and press apply to confirm.",
  NOT_ACCEPTED_PRODUCT = "Please select why this product cannot be accepted",
  NOT_ACCEPTED_FORWARDER = "Please select why this forwarder cannot be accepted",
  REJECTED_WITH_NEW_CAP = "Reject with New Capacity submitted successfully.",
  REJECTED_SUCCESS = "Reject with selected reason submitted successfully.",
  APPLY_TO_CONFIRM = "Press apply to confirm.",
}
